import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { TributacaoTipo } from '@/features/fiscal/enum/TributacaoTipo';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalPisSchema = z.object({
    rpi_cst_pis: z.string().nullable(),
    rpi_destino: z.enum(DestinoNotaFiscal).nullable(),
    rpi_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rpi_empresa_idpk: z.number(),
    rpi_estado_especifico: z.string().nullable(),
    rpi_idpk: z.number(),
    rpi_motivo: z.number().nullable(),
    rpi_perfil_cliente: z.enum(ClienteFiscalPerfil),
    rpi_pis_descontar_icms: z.enum(['S', 'N', '']).transform((v) => (v === '' ? 'N' : v)),
    rpi_pis_percentual: z.number().nullable(),
    rpi_pis_valor: z.number().nullable(),
    rpi_pisst_descontar_icmsst: z.enum(['S', 'N', '']).transform((v) => (v === '' ? 'N' : v)),
    rpi_pisst_percentual: z.number().nullable(),
    rpi_pisst_valor: z.number().nullable(),
    rpi_regra_fiscal_idpk: z.number(),
    rpi_tipo: z.enum(NotaFiscalTipo).nullable(),
    rpi_tipo_cliente: z.enum(TipoCliente).nullable(),
    rpi_tipo_tributacao: z.enum(TributacaoTipo).nullable(),
    rpi_tipo_tributacao_st: z.enum(TributacaoTipo).nullable(),
    rpi_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
});

type RegraFiscalPis = z.infer<typeof RegraFiscalPisSchema>;

export type RegraFiscalPisBody = PartialUndefinedOrNull<RegraFiscalPis> & TableEditItem;
